import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [showForm, setShowForm] = useState(false);
  const [stockAdjustmentShowForm, setStockAdjustmentShowForm] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openDSR, setOpenDSR] = useState(false);
  const [dateDSR, setDateDSR] = useState(new Date());
  const [showPreviewDSR, setShowPreviewDSR] = useState(false);
  return (
    <AppContext.Provider
      value={{
        showForm,
        setShowForm,
        stockAdjustmentShowForm,
        setStockAdjustmentShowForm,
        openPaymentModal,
        setOpenPaymentModal,
        openDSR,
        setOpenDSR,
        dateDSR,
        setDateDSR,
        showPreviewDSR,
        setShowPreviewDSR,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
